import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const Buyout = new Entity('buyouts')

Buyout.postBatchCreate = async (params) => {
  return (await bobtailAPI()).post(`${Buyout.baseUrl}/batch-create`, {
    ...params,
  })
}
Buyout.bulkDelete = async (params) => {
  return (await bobtailAPI()).post(`${Buyout.baseUrl}/bulk-destroy`, {
    ...params,
  })
}

Buyout.bulkApprove = async (params) => {
  return (await bobtailAPI()).post(`${Buyout.baseUrl}/bulk-approve`, {
    ...params,
  })
}

export default Buyout
